import React, {Component} from 'react';
import * as El from '../components/formEl';
import * as Errors from '../Tools/ErrorHandle';
import { Birthday, BG, BDayBtn, Summer, Winter, Fall, Spring} from '../components/birthdayForm.js';

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responseErr: false,
      responseToPost: '',
      FirstName: {
        Value: '',
        Error: null,
        ErrCode: 200,
        ErrorMsg: '',
        Blur: false,
        ErrorCount: 0
      },
      LastName: {
        Value: '',
        Error: null,
        ErrCode: 200,
        ErrorMsg: '' ,
        Blur: false,
        ErrorCount: 0
      },
      Email: {
        Value: '',
        Error: null,
        ErrCode: 200,
        ErrorMsg: '',
        Blur: false,
        ErrorCount: 0
      },
      How: {
        Value: '',
        Error: null,
        ErrCode: 200,
        ErrorMsg: '',
        Blur: false,
        ErrorCount: 0
      },
      BDay: null,
      BMonth: '',
      BNum: null,
      Display: {
        Day: false,
        Month: false,
        BG: false
      },
      BtnViz: false,
      moreInfo: {
        Display: false
      }
    };
    // this.handleEError = this.handleEError.bind(this);
    // this.handleHError = this.handleHError.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.handleBlur = this.handleBlur.bind(this);
    this.bdayChange = this.bdayChange.bind(this);
    this.bdayClick = this.bdayClick.bind(this);
  }
  
  componentDidMount() {
    // this.callApi()
    //   .then(res => this.setState({ response: res.express }))
    //   .catch(err => console.log(err));
  }

  callApi = async () => {
    // const response = await fetch('/api/hello');
    // const body = await response.json();
    // if (response.status !== 200) throw Error(body.message);
    // return body;
  };
    
  handleSubmit = async e => {
    e.preventDefault();
    var Bnm = null;
    ((this.state.BNum !== null && (this.state.BDay === null || this.state.BDay === '') ? Bnm = null : Bnm = this.state.BNum ))
    const response = await fetch('/api/74f05d6b-572b-4a71-8231-43944db830e0', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ FirstName: this.state.FirstName.Value, LastName: this.state.LastName.Value, Email: this.state.Email.Value, Day: this.state.BDay, Month: Bnm, HowHear: this.state.How.Value }),
    });
    const body = await response.text();
    if(response.status == 200 ) {
      this.setState({ responseToPost: `Congrats ${this.state.FirstName.Value} you\'re subscribed!`, responseErr: false });
    } else if(body == 400) {
      this.setState({ responseToPost: 'One of the fields is blank', responseErr: true});
    } else {
      this.setState({ responseToPost: 'General Error. We\'re sorry for this inconvenience ', emailViz: true, responseErr: true });
    }
  };
  func = e => {
    this.setState(prevstate => ({moreInfo:{Display: !prevstate.moreInfo.Display}}));
  }
  handleChange = (e) => {
    var targ = e.target;
    var Name = targ.getAttribute('name');
    var submitDisplay = true;
    var inputs = ['FirstName', 'LastName', 'Email' ];
    var err = false;
    var errorCount = this.state[Name].ErrorCount;
    var msg = '';
    var errC = 200;
    if(Name === 'How') {
      var arr = Errors.how(targ.value);
      err = arr[0];
      msg = arr[1];
    } else {
      if(targ.value === null || targ.value === '') {
        err = true;
        msg = 'This field should not be blank.';
      } else {
        if(Name === 'Email') {
          var arr = Errors.email(targ.value.toString());
          errC = arr[0];
          msg = arr[1];
          err = arr[2];
        }
      } 
    }
    if(err && Name != 'How') {
      errorCount+=1;
      submitDisplay = false;
    } else {
      var ind;
      for(var i = 0; i<inputs.length; i++) { //Find the one we're error checking
        if(inputs[i] === Name) {
          ind = i;
        }
      }
      for(var i = 0; i < inputs.length; i++) {
        if(i < ind && (this.state[inputs[i]].Value === null || this.state[inputs[i]].Value === '')) {
          // submitDisplay = false;
          var input = inputs[i];
          this.setState(prevstate => ({[input]: {
                Error: true,
                Value: prevstate[input].Value,
                Blur: true,
                ErrorMsg: 'This field should not be blank.',
                ErrCode: prevstate[input].ErrCode,
                ErrorCount:  prevstate[input].ErrorCount + 1
          }}));
        }
      }
      inputs.splice(ind,1); //Remove that from list
      for(var i = 0; i < inputs.length; i++ ) { //check to see if the rest have errors or null
        if(this.state[inputs[i]].Error || (this.state[inputs[i]].Error === null)) {
          submitDisplay = false;
        }
      }
    }
    this.setState({[Name]:{Value: [targ.value], Blur: true, Error: err, ErrorCount: errorCount, ErrCode: errC, ErrorMsg: msg}, BtnViz: submitDisplay});
  }
  bdayChange(e) {
    var Months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var Nums = ['01','02','03','04','05','06','07','08','09','10','11','12'];
    if(e.target.getAttribute('name') === 'BDay') {
      var Num;
      if(e.target.value.split('').length < 2) {
        Num = '0' + e.target.value;
      } else {
        Num = e.target.value;
      }
      this.setState({[e.target.getAttribute('name')]: Num, Display:{Month: false, Day: false, BG: false}});
    } else {
      var Num;
      for(var x=0; x <= Nums.length; x++) {
        if(e.target.value === Months[x]) {
          Num = Nums[x];
        }
      }
      console.log(Num);
      this.setState({[e.target.getAttribute('name')]: e.target.value, Display:{Month: false, Day: true, BG: true}, BNum: Num});
    }
  }
  bdayClick(e) {
    e.preventDefault();
    if(e.target.getAttribute('name') == 'BG' || e.target.getAttribute('name') == 'BDay') {
      this.setState({Display:{Month: false, Day: false, BG: false }});
    } else if (e.target.getAttribute('name') === 'BMonth') {
      this.setState({Display:{Month: false, Day: true, BG: true}});
    } else if (e.target.getAttribute('name') === 'backBtn' || e.target.getAttribute('name') === 'Btn') {
      this.setState({Display:{ Month: true, Day: false, BG: true}});
    }
  }

  render() {
      return (    
        <div style={{position:'static'}}>
            <El.BoxImg/>
            <El.Form onSubmit={ e => this.handleSubmit(e)}>
              <El.FormBackground>
              <Birthday onClick={this.bdayClick} Day={this.state.BDay} Month={this.state.BMonth} onChange={this.bdayChange} Display={this.state.Display} />
                <El.Outline style={{paddingBottom: '0'}}>
                  <div style={{backgroundColor: 'white', zIndex:3, position:'relative'}}>
                    <El.InputGroup error={this.state.FirstName.Error} blur={this.state.FirstName.Blur} ErrorCount={this.state.FirstName.ErrorCount} msg={this.state.FirstName.ErrorMsg} name="FirstName" placeholder="FIRST NAME" onChange={this.handleChange} value={this.state.FirstName.Value} />
                    <El.InputGroup error={this.state.LastName.Error} msg={this.state.LastName.ErrorMsg} name="LastName" placeholder="LAST NAME" onChange={this.handleChange} value={this.state.LastName.Value} blur={this.state.LastName.Blur} ErrorCount={this.state.LastName.ErrorCount} />
                    <El.InputGroup error={this.state.Email.Error} msg={this.state.Email.ErrorMsg} name="Email" placeholder="EMAIL" onChange={this.handleChange} value={this.state.Email.Value} blur={this.state.Email.Blur} ErrorCount={this.state.Email.ErrorCount} />
                  </div>
                </El.Outline>
              </El.FormBackground>
              <El.Outline style={{paddingTop: '0'}}>
                <El.SubmitButton emailViz={this.state.emailViz} responseToPost={this.state.responseToPost} responseErr={this.state.responseErr} error={this.state.Email.Error} Display={this.state.BtnViz} moreInfo={this.func} mI={this.state.moreInfo.Display} type="submit">
                  <El.hiddenFields Display={this.state.moreInfo.Display} error={this.state.Email.Error} >
                    <div style={{backgroundColor:'white', height: 'auto'}}>
                      <BDayBtn name='Btn' onClick={this.bdayClick}>{(this.state.BMonth === '' ? 'Birthday' : <span onClick={this.bdayClick}>{this.state.BMonth} {this.state.BDay} <Summer Click={this.bdayClick} Month={this.state.BNum}/><Spring Click={this.bdayClick} Month={this.state.BNum}/><Fall Click={this.bdayClick} Month={this.state.BNum}/><Winter Click={this.bdayClick} Month={this.state.BNum}/></span>)}</BDayBtn>
                      <El.NoDotInput error={this.state.How.Error} msg={this.state.How.ErrorMsg} name="How" placeholder="HOW DID YOU HEAR ABOUT US?" onChange={this.handleChange} value={this.state.How.Value} blur={this.state.How.Blur} ErrorCount={this.state.How.ErrorCount} />
                    </div>
                  </El.hiddenFields>
                </El.SubmitButton>
                {/* <El.ErrLbl error={this.state.responseErr}>{this.state.responseToPost}{(this.state.emailViz ? <El.OopsEmail href="mailto:stephen@sisterindia.org">Admin</El.OopsEmail> : '' )}</El.ErrLbl> */}
              </El.Outline>
            </El.Form>
        </div>
    );
  }
}
export default Form;